<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='讲员列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-button type="primary" @click="showAddDialog">添加讲员</el-button>
        </el-col>
        <el-col :span="7">
          <el-input placeholder="请输入讲员姓名" v-model="param.keywords" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :data="speakerList" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="avatar" label="头像" align="center">
          <template slot-scope="scope">
            <el-image :src="scope.row.avatar+'?imageView2/0/w/50'" class="speaker_avatar"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="intro" label="简介" align="center"></el-table-column>
        <el-table-column prop="admin_level" label="管理员等级" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.status === 10 ? '正常' : '隐藏'}}
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
    <speaker-add :visible="addDialogAvaible"
      :id="currentId"
      @add="addSpeaker"
      @update="updateSpeaker"
      @close="closeAddDialog">
    </speaker-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import SpeakerAdd from './SpeakerAdd.vue'
export default {
  name: 'speaker_list',
  components: {
    'bread-crumb': BreadCrumb,
    'speaker-add': SpeakerAdd
  },
  data () {
    return {
      currentId: 0,
      speakerList: [],
      total: 0,
      pageTotal: 1,
      param: {
        keywords: '',
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getSpeakerList()
  },
  methods: {
    async getSpeakerList () {
      const res = await this.$http.get('/admin/speaker/list', this.param)
      if (res.code === 0) {
        this.speakerList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getSpeakerList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getSpeakerList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getSpeakerList()
    },
    async addSpeaker (data) {
      const res = await this.$http.post('/admin/speaker/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getSpeakerList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateSpeaker (id, data) {
      const res = await this.$http.post('/admin/speaker/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getSpeakerList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/speaker/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getSpeakerList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.speaker_avatar {
  width: 50px;
}
</style>
